module.exports = __webpack_public_path__ + "static/media/loginBg.3239eae8.jpg";